export enum USER_ROLE {
  OWNER = 'Owner',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  WORKER = 'Worker',
  SITE_ADMIN = 'SiteAdmin',
  GUEST = 'Guest',
}

export const USER_ROLE_LIST = [
  USER_ROLE.OWNER,
  USER_ROLE.ADMIN,
  USER_ROLE.SITE_ADMIN,
  USER_ROLE.MANAGER,
  USER_ROLE.WORKER,
  USER_ROLE.GUEST,
] as const;

export const MUTABLE_USER_ROLE_LIST = [
  USER_ROLE.SITE_ADMIN,
  USER_ROLE.MANAGER,
  USER_ROLE.WORKER,
] as const;

// 프로젝트·컬렉션·모델링·관리자 설정 같은 관리 화면에 들어갈 수 없는 역할입니다
export const MANAGEMENT_DENIED_USER_ROLE_LIST = [
  USER_ROLE.WORKER,
  USER_ROLE.GUEST,
];

export const MEMBER_ROUTE_PATH = '/member';
